
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
const ComponentsBreadcrumb = (props) => {
  const extraBreadcrumbItems = props.breadCrumbList?.map((name, index) => {
    return (
      <Breadcrumb.Item key={name.url} className=''>
        {name.url && <Link to={name.url} className={index === props.breadCrumbList?.length - 1 ? '!text-darkWhite !text-lg !font-semibold' : '!text-breadcrumColor !text-lg !font-semibold hover:!text-subTextColor cursor-pointer'}>{name.bname}</Link>}
        {!name.url && <p className={index !== props.breadCrumbList?.length - 1 ? '!text-breadcrumColor !text-lg !font-semibold' : '!text-lg !font-semibold !text-darkWhite md:!w-60 !text-ellipsis overflow-hidden'}>{name.bname}</p>}
      </Breadcrumb.Item>

    );
  });
  const breadcrumbItems = [
    <Breadcrumb.Item key="/dashboard"></Breadcrumb.Item>,
  ].concat(extraBreadcrumbItems);

  return (
    <Breadcrumb className='mb-0 !items-center' separator={<span className='icon bc-arrow' />}>{breadcrumbItems}</Breadcrumb>)
}

export default ComponentsBreadcrumb;